


$(window).ready(function() {
    function isTouchDevice() {
        return (('ontouchstart' in window)
                || (navigator.MaxTouchPoints > 0)
                || (navigator.msMaxTouchPoints > 0));
    }

    $('#product-images-slider').carouFredSel({
        circular: true,   
        infinite: true,           
        responsive: true,         
        direction: "left",      
        align: "center",        
        cookie: false,
        onWindowResize: "debounce",
        auto: false,
        mousewheel: false,  //change to false
        width: 1000,
        swipe: {
	    onMouse: true,
	    onTouch: true
	},
        items: {
            visible: 1,
            start: 0,
            width: 1000,            
        },
        scroll: {
            onAfter: function(data) {
                $('#product-images-thumbs-large a').removeClass('selected');
                $('#product-images-thumbs-medium a').removeClass('selected');

                var largeSelectedThumb = $('#product-images-thumbs-medium a#tl-medium-' + data.items.visible.first().attr('id'));
                if (largeSelectedThumb) {
                    largeSelectedThumb.addClass('selected');
                }

                var mediumSelectedThumb = $('#product-images-thumbs-large a#tl-large-' + data.items.visible.first().attr('id'));
                console.log(mediumSelectedThumb);
                if (mediumSelectedThumb) {
                    mediumSelectedThumb.addClass('selected');
                }
                
            }
        },
        pagination: "#pager"
    }).trigger('resize');

    $('#product-images-thumbs-large a').click(function(e) {
        e.preventDefault();
	$('#product-images-slider').trigger('slideTo', '#' + this.href.split('#').pop() );
 	$('#product-images-thumbs-large a').removeClass('selected');
	$(this).addClass('selected');
	return false;
    });

    $('#product-images-thumbs-medium a').click(function(e) {
        e.preventDefault();
	$('#product-images-slider').trigger('slideTo', '#' + this.href.split('#').pop() );
 	$('#product-images-thumbs-medium a').removeClass('selected');
	$(this).addClass('selected');
	return false;
    });

    $('#product-images-slider').trigger('slideToPage', 0).trigger('resize');    
    
    //endable zooming on non0touch devices
    if (!isTouchDevice()) {        
        CloudZoom.quickStart();
    }
});

